import { UserRequestFilters } from '@/api/requests/users/user-request-filters';
import { UserApi } from '@/api/user';
import { State } from '@/stores/users/state';
import { camelCase } from '@/string-utilities';
import { ActionContext, ActionTree } from 'vuex';

const userApi = new UserApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public loadUsersAsync = async (context: ActionContext<State, any>, payload: { type: string, filters: UserRequestFilters }) => {
        const formattedType = camelCase(`load ${payload.type}${(!payload.type.toLowerCase().endsWith('type') ? 'Users' : 's')} Async`);
        await context.dispatch(formattedType, payload.filters);
    }

    public loadAllUsersAsync = async (context: ActionContext<State, any>) => {
        const response = await userApi.getUsersAsync();
        context.commit('setUsers', response);
    }

    public loadLegalAdvisorUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getLegalAdvisorsAsync(filters);
        context.commit('setLegalAdvisorUsers', response);
    }

    public loadAppointmentBookerUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getAppointmentBookersAsync(filters);
        context.commit('setAppointmentBookerUsers', response);
    }

    public loadInteractionAuthorUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getInteractionCreatorsAsync(filters);
        context.commit('setInteractionAuthorUsers', response);
    }

    public loadAssignedTaskUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getAssignedTaskUsersAsync(filters);
        context.commit('setAssignedTaskUsers', response);
    }

    public loadCompletedTaskUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getCompletedTaskUsersAsync(filters);
        context.commit('setCompletedTaskUsers', response);
    }

    public loadAccountAuthorUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getAccountCreatorsAsync(filters);
        context.commit('setAccountAuthorUsers', response);
    }

    public loadAssignedCallUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getAssignedCallUsersAsync(filters);
        context.commit('setAssignedCallUsers', response);
    }

    public loadAccountAccessUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getAccessedAccountUsersAsync(filters);
        context.commit('setAccountAccessUsers', response);
    }

    public loadTargetUsersAsync = async (context: ActionContext<State, any>, filters: UserRequestFilters) => {
        const response = await userApi.getTargetUsersAsync(filters);
        context.commit('setTargetUsers', response);
    }

    public loadRolesAsync = async (context: ActionContext<State, any>) => {
        const response = await userApi.getRolesAsync();
        context.commit('setRoles', response);
    }
}
